import useAppStore from "@/context/store";
import { getSeoInlinks } from "@/services/qingzhou";
import loginTracker from "@/tracker/report/loginTracker";
import registTracker from "@/tracker/report/registTracker";
import { useSafeState, useUpdateEffect } from "ahooks";
import classNames from "classnames";
import _ from "lodash";
import { useRouter } from "next/router";
import {
  Children,
  cloneElement,
  isValidElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Transition } from "react-transition-group";
import { getMe, getSignup } from "../../services";
import HBIcon from "../HBIcon";
import { Logo } from "../Header";
import { useLogin } from "../LoginModal";
import { ThirdLogin } from "../LoginModal/shared/third";
import { WxLogin } from "../LoginModal/shared/wxLogin";
import styles from "./index.module.less";

export default function LaunchBottom({ inlinks, disabledModalOpenWidth }) {
  const { login } = useLogin();
  const { user, userReady, setUser } = useAppStore(
    ({ user, setUser, userReady }) => ({
      user,
      userReady,
      setUser,
    })
  );
  const router = useRouter();
  const pathname = router.pathname;
  const isHome = pathname === "/";

  const [visible, setVisible] = useState(isHome);
  const [qrcodeVis, setQrcodeVis] = useSafeState(false);

  const wxRef = useRef();

  const disabled = !userReady || user;

  useEffect(() => {
    if (isHome) {
      setVisible(true);
    }
  }, [isHome]);

  useEffect(() => {
    const onWheel = _.throttle((evt) => {
      if (evt.wheelDelta <= 0) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }, 500);

    if (disabled) {
      return;
    }
    if (!isHome) {
      window.addEventListener("wheel", onWheel, { passive: true });
      return () => {
        window.removeEventListener("wheel", onWheel, { passive: true });
      };
    }
  }, [disabled, isHome]);

  // useEffect(() => {
  //   if (!disabled) {
  //     getWxLoginScript().then(() => {
  //       var obj = new WxLogin({
  //         self_redirect: false,
  //         id: "dsaf",
  //         appid: "wxadc3342faa49acef",
  //         scope: "snsapi_login",
  //         redirect_uri: "https://huaban.com/boards/73879565",
  //         state: "",
  //         style: "",
  //         href: "",
  //       });
  //       console.log(obj);
  //     });
  //   }
  // }, [disabled]);

  const onLogin = useCallback(
    async (type) => {
      if (!user) {
        await login({ initType: type || "register" });
      }
    },
    [login, user]
  );

  const onThirdLogin = useCallback(
    async (data) => {
      if (data.isRegister) {
        registTracker(data.loginType, data.user.user_id);
      } else {
        loginTracker({
          userId: data.user.user_id,
          login_type: data.loginType,
          is_cache_login: false,
        });
      }
      setUser(data.user);
    },
    [setUser]
  );

  const onWxLogin = useCallback(
    async (res) => {
      wxRef.current.refresh();
      if (res.user) {
        const data = {};
        data.loginType = "wechat";
        const user = await getMe();
        data.user = user;
        onThirdLogin(data);
      } else {
        await await getSignup();
        const user = await getMe();
        onThirdLogin({
          isRegister: true,
          loginType: "wechat",
          user,
        });
      }
    },
    [onThirdLogin]
  );
  // 登录了就不用展示了
  if (disabled) {
    return null;
  }

  return (
    <>
      <div
        className={classNames([
          styles.bottom,
          !disabledModalOpenWidth ? "modalOpenWidth" : null,
          visible ? styles.active : null,
          isHome ? styles.isHome : null,
        ])}
        data-content-source="底部栏"
      >
        <div className={styles.wrap}>
          <div className={styles.left}>
            <div className={styles.img}>
              <Logo hasText width={66} height={20} />

              {/* <img
            src="//cdn.dancf.com/fe-assets/img/09b63a4cb94a263380ea9bb8074ec59a.png"
            alt="背景图"
          /> */}
            </div>
            <div className={styles.title}>发现、采集你喜欢的一切</div>
            <a
              className={styles.more}
              href="//s.gd-share.cn/4fqg"
              target="_blank"
              rel="noreferrer nofollow"
              data-gd-click="button_click"
              data-button-name="了解更多"
            >
              了解更多
            </a>
          </div>
          <div className={styles.right}>
            <div
              className={styles.phone}
              onClick={() => onLogin()}
              data-gd-click="button_click"
              data-button-name="手机号登录"
            >
              <HBIcon type="icon" />
            </div>
            <ThirdLogin onOk={onThirdLogin} />
            <div
              onMouseEnter={() => {
                setQrcodeVis(true);
              }}
              onMouseLeave={() => {
                setQrcodeVis(false);
              }}
            >
              <div
                className={styles.wechat}
                onClick={() => onLogin("wechat")}
                data-gd-click="button_click"
                data-button-name="微信扫码登录"
              >
                <HBIcon type="ic_wechat1" />
                微信扫码登录
              </div>

              <FadeRightIn bottom={60} appear={qrcodeVis}>
                <div
                  className={styles.qrcodeWrap}
                  onClick={() => onLogin("wechat")}
                >
                  {qrcodeVis && (
                    <div
                      data-dialog-title="微信登录二维码"
                      data-gd-expose="dialog_expose"
                    >
                      <WxLogin ref={wxRef} size={70} onLogin={onWxLogin} />
                    </div>
                  )}
                </div>
              </FadeRightIn>
            </div>
          </div>
        </div>

        {!isHome && <PageInlinks inlinks={inlinks} />}
      </div>
    </>
  );
}

/**
 * 从右到左，透明到显示的渐变显示
 */
function FadeRightIn({
  children,
  duration = 300,
  delay = 100,
  bottom,
  appear,
} = {}) {
  const transitionStyles = {
    entering: { bottom, opacity: 0 },
    entered: { bottom: 55, opacity: 1 },
    exiting: { bottom: 55, opacity: 1 },
    exited: { bottom, opacity: 0 },
  };

  const defaultStyle = {
    transition: `all ${duration}ms ease-in-out`,
    opacity: 0,
    bottom,
    right: -5,
  };

  return (
    <Transition in={appear} timeout={delay}>
      {(state) =>
        Children.map(children, (child) => {
          if (!isValidElement(child)) {
            return null;
          }
          const childStyle = child.props.style || {};

          const childProps = {
            ...child.props,
            style: {
              ...childStyle,
              ...defaultStyle,
              ...transitionStyles[state],
            },
          };
          return cloneElement(child, childProps);
        })
      }
    </Transition>
  );
}

export function PageInlinks({ inlinks }) {
  const router = useRouter();
  const [links, setLinks] = useState(inlinks || []);
  const pathname = router.pathname;
  const isHome = pathname === "/";

  useUpdateEffect(() => {
    getSeoInlinks({
      current_url: isHome ? "home" : window.location.pathname,
      title: document.title,
    }).then((res) => {
      if (res?.length > 0) {
        setLinks(res);
      }
    });
  }, [router]);

  if (!links?.length) {
    return null;
  }

  return (
    <div className={styles.inlinks}>
      你可能感兴趣：
      {links?.map((item, index) => (
        <a key={index} href={item.url} target="_blank" rel="noreferrer">
          {item.keyword}
        </a>
      ))}
    </div>
  );
}
